<template>
  <SurveyCreate :id="id" />
</template>

<script>
import SurveyCreate from "./SurveyCreate.vue";

export default {
  name: "SurveyEdit",
  components: { SurveyCreate },
  props: { id: { type: [String, Number], required: true } },
};
</script>
